import { MessageCircle } from "lucide-react";
import { WHATSAPP_NUMBER } from "../lib/site";

const MESSAGE = encodeURIComponent(
    "Hello FnB International — I'm interested in your export collections. Could you share your wholesale catalog and MOQ details?"
);

export const WhatsAppFloat = () => (
    <a
        data-testid="whatsapp-float-btn"
        href={`https://wa.me/${WHATSAPP_NUMBER}?text=${MESSAGE}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with FnB International on WhatsApp"
        className="group fixed bottom-6 right-6 z-50 flex items-center"
    >
        <span className="max-w-0 overflow-hidden group-hover:max-w-[180px] transition-all duration-500 whitespace-nowrap">
            <span className="mr-3 px-4 py-2 rounded-sm bg-[#1D1814] border border-[#2E2620] text-[12px] tracking-[0.12em] uppercase text-[#E2D4C9]">
                Chat on WhatsApp
            </span>
        </span>
        <span className="relative wa-pulse w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-lg shadow-black/40 transition-transform duration-300 group-hover:scale-105">
            <MessageCircle size={24} className="text-[#0F0C08] relative z-10" fill="#0F0C08" strokeWidth={1} />
        </span>
    </a>
);
